import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/business/user/authentication.service';

@Injectable()
export class LoginGuardService  {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticationService.isConnected$.pipe(
      map(isLoggedIn => {
        if (this.authenticationService.checkConnection()) {
          this.router.navigateByUrl('/dashboard');
        }
        return !this.authenticationService.checkConnection();
      })
    );
  }
}
